import { useCallback, useState } from 'react';
import { ControllerLeftNavColor, makeStyles, Theme } from '@bymason-private/controller-v1-theme-provider';
import { FaChevronLeft, Fab, Fade } from '@bymason-private/legacy-pattern-components';

interface ExpandCollapseButtonProps {
  collapse: boolean;
  navWidth: number;
  onClick: () => void;
  show: boolean;
}

const BUTTON_SIZE = 32;

const useStyles = makeStyles<Theme, { collapse: boolean; navWidth: number }>((theme) => ({
  root: {
    position: 'fixed',
    left: ({ navWidth }) => `${navWidth - BUTTON_SIZE / 2 - 1}px`,
    bottom: 308,
    transform: ({ collapse }) => (collapse ? 'rotate(180deg)' : 'rotate(0deg)'),
    transition: 'all .25s ease-out',
    transitionProperty: 'left, transform',
    zIndex: theme.zIndex.drawer,
  },
  fab: {
    backgroundColor: ControllerLeftNavColor.ExpandCollapseButtonBg,
    boxShadow: 'none',
    color: ControllerLeftNavColor.ExpandCollapseButtonFg,
    height: BUTTON_SIZE,
    minHeight: BUTTON_SIZE,
    width: BUTTON_SIZE,
    '&:hover': {
      backgroundColor: ControllerLeftNavColor.ExpandCollapseButtonBg,
    },
  },
}));

export default function ExpandCollapseButton({
  collapse,
  navWidth,
  onClick,
  show,
}: ExpandCollapseButtonProps) {
  const classes = useStyles({ collapse, navWidth });
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = useCallback(() => {
    setIsHovering(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovering(false);
  }, []);

  return (
    <div className={classes.root}>
      <Fade in={isHovering || show} timeout={{ enter: 250, exit: collapse ? 1500 : 500 }}>
        <Fab
          classes={{ root: classes.fab }}
          color='primary'
          onClick={onClick}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          <FaChevronLeft />
        </Fab>
      </Fade>
    </div>
  );
}
